
namespace Gordic.Epk.WebControls {

    export interface IGEpkGridFormatOpt {
        typSeznamu: Wfl.Interface.TypSeznamuEpk
        /** EPK - dny do termínu (těsně nevyřízené záznamy) */
        gin_epk_updoter: number
        /**  SSL EPK - Uživatelský sloupec F - název sloupce zobrazovaný uživateli */
        epk_uziv_sl_fn: string
        /** text. číslo jednací */
        textCJShortDBParam: string
        /** Jedná se o fázi USU? */
        isFazeUsu: boolean
        /** text. značka */
        znackaShortText: string
        /** Gordic.Epk.WebControls.GEpkActionsService */
        epkAction: GContent;
        /** SSL EPK - Rozšíření pro odsouhlasení přidělení/předání dokumentů a vyřízení spisů */
        ssl_epk_plus2: boolean;

        povoleniFikceVyrizeni: boolean;
    }

    export class GEpkGridFormat {

        //#region -- atributy --
        private typSeznamu: Wfl.Interface.TypSeznamuEpk;
        private columns: GEpkGridFormatColumnsInternal;
        /** Gordic.Epk.WebControls.GEpkActionsService */
        private epkAction: GContent;
        /**  SSL EPK - Uživatelský sloupec F - název sloupce zobrazovaný uživateli */
        private epk_uziv_sl_fn: string;
        /** EPK - dny do termínu (těsně nevyřízené záznamy) */
        private gin_epk_updoter: number;
        /** text. číslo jednací */
        private textCJShortDBParam: string;
        /** Jedná se o fázi USU? */
        private isFazeUsu: boolean;
        /** text. značka */
        private znackaShortText: string;
        /** SSL EPK - Rozšíření pro odsouhlasení přidělení/předání dokumentů a vyřízení spisů */
        private ssl_epk_plus2: boolean;
        /** povolení políčka uzo */
        private readonly: (row?:any)=> boolean;
        private povoleniFikceVyrizeni: boolean;
        //#endregion

        constructor(opt: IGEpkGridFormatOpt, readonly: (row?: any) => boolean, globalSettings?: Gordic.Data.IGStorage | null) {
            this.typSeznamu = opt.typSeznamu;
            this.epk_uziv_sl_fn = opt.epk_uziv_sl_fn;
            this.gin_epk_updoter = opt.gin_epk_updoter;
            this.textCJShortDBParam = opt.textCJShortDBParam;
            this.isFazeUsu = opt.isFazeUsu;
            this.znackaShortText = opt.znackaShortText;
            this.epkAction = opt.epkAction;
            this.ssl_epk_plus2 = opt.ssl_epk_plus2;
            this.columns = new GEpkGridFormatColumnsInternal(globalSettings);
            this.readonly = readonly;
            this.povoleniFikceVyrizeni = opt.povoleniFikceVyrizeni;
        }

        public gridFormatMobile(format: Gordic.Data.GridFormat) {

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getZpusobVyriz(format);
                this.columns.getDatVyrizeni(format);
            }

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getPriorita(format);
            }

            if (this.povoleniFikceVyrizeni === true)
                this.columns.getPrizFikceVyrizen(format);           // thazmuka 13.10.2021 - příznak fikce vyřízení

            this.columns.getVec(format);
            this.columns.getVecSpis(format);
            this.columns.getTypPozadPodTxt(format); // upřesnění

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getTerminVyrizeni(format, this.gin_epk_updoter);

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getTypPoz(format);
                this.columns.getVyrizeniTxt(format);
            }

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                this.columns.getDatVyrizeni(format);

            this.columns.getTermin(format);
            this.columns.getCj(format, this.znackaShortText);
            this.columns.getCjSpis(format, this.textCJShortDBParam, this.isFazeUsu);

            this.columns.getFunOdNazev(format);
            this.columns.getIxp(format);

            return this.getStringNamesOfColumns(format.columns);
        }

        public gridFormatMobile2(format: Gordic.Data.GridFormat) {

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getPriorita(format);

            if (this.povoleniFikceVyrizeni === true)
                this.columns.getPrizFikceVyrizen(format);           // thazmuka 13.10.2021 - příznak fikce vyřízení

            this.columns.getVec(format);
            this.columns.getVecSpis(format);
            this.columns.getTypPozadPodTxt(format); // upřesnění

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getTerminVyrizeni(format, this.gin_epk_updoter);

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getZpusobVyriz(format);
                this.columns.getTypPoz(format);
                this.columns.getVyrizeniTxt(format);
                this.columns.getDatVyrizeni(format);
            }

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti)
                this.columns.getDatVyrizeni(format);

            this.columns.getTermin(format);
            this.columns.getCj(format, this.znackaShortText);
            this.columns.getCjSpis(format, this.textCJShortDBParam, this.isFazeUsu);

            this.columns.getFunOdNazev(format);
            this.columns.getIxp(format);

            return this.getStringNamesOfColumns(format.columns);
        }


        public gridFormatSimple(format: Gordic.Data.GridFormat) {

            var format = new Gordic.Data.GridFormat();

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getTerminVyrizeni(format, this.gin_epk_updoter);
            }

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getPriorita(format);
            }

            this.columns.getTechnickeVlastnosti(format);
            this.columns.getTypEntity(format);

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno) {
                this.columns.getZpusobVyriz(format);
                this.columns.getTypPoz(format);
                this.columns.getVyrizeniTxt(format);
                this.columns.getDatVyrizeni(format);
            }

            if (this.typSeznamu === Wfl.Interface.TypSeznamuEpk.VlastniZadosti) {
                this.columns.getDatVyrizeni(format);
            }

            this.columns.getTermin(format);
            this.columns.getVec(format);
            this.columns.getVecSpis(format);
            this.columns.getCj(format, this.znackaShortText);
            this.columns.getCjSpis(format, this.textCJShortDBParam, this.isFazeUsu);

            this.columns.getFunOdNazev(format);
            this.columns.getTypPozadPodTxt(format);
            this.columns.getZmenuProv(format);
            this.columns.getNazevPrimAgendy(format);
            this.columns.getIxp(format);

            this.columns.getUzivSloupec(format, this.epk_uziv_sl_fn);

            return this.getStringNamesOfColumns(format.columns);

        }

        /**
         * pro posouzeno, vráceno k přepracování a v posouzení
         * @param format
         */
        public gridFormatBasicDone(format: Gordic.Data.GridFormat) {

            // for test
            //this.columns.getUzo(format, this.readonly);

            this.columns.getStavSchvalPredpis(format);
            this.columns.getVec(format);
            this.columns.getVecSpis(format);
            this.columns.getCj(format, this.znackaShortText);   // značka
            this.columns.getTypPozadPodTxt(format); // upřesnění
            this.columns.getFunOdNazev(format);     // žadatel
            this.columns.getDatVyrizeni(format);    // datum vyřízení
            this.columns.getVyrizeniTxt(format);    // popis vyřízení
            this.columns.getIxp(format);
            this.columns.getNazevTyp(format);       // typ dokumentu
            this.columns.getNazevPrimAgendy(format);// název prim. agendy
            this.columns.getPIDPrimDokladu(format); // PID v prim. agendě
            this.columns.getNazevFunAkt(format);    // vlastník
            this.columns.getNazevSablony(format);

            if (this.ssl_epk_plus2 === true) {
                this.columns.getIxsSuDoNazev(format);
                this.columns.getIxsFunDoNazev(format);
            }

            //---

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getTerminVyrizeni(format, this.gin_epk_updoter);

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getPriorita(format);

            this.columns.getRequestAttachment(format);
            this.columns.getTechnickeVlastnosti(format);
            this.columns.getVyrizDokument(format);

            this.columns.getTypPoz(format);
            this.columns.getTermin(format);
            this.columns.getFunVyriz(format);       // thazmuka (25.8.2021) - změna sloupce vyřizuje za vyřizoval (ixs_zmp_vyriz)

            if (this.typSeznamu !== Wfl.Interface.TypSeznamuEpk.PosouzenoSchvaleno)
                this.columns.getNavaznost(format);

            this.columns.getTypEntity(format);
            this.columns.getStavPisemnost(format);
            this.columns.getSouvisDok(format);

            this.columns.getCjSpis(format, this.textCJShortDBParam, this.isFazeUsu);
            this.columns.getDatPozad(format);
            this.columns.getNazevSuAkt(format);
            this.columns.getSouborPri(format);
            this.columns.getPocPriloh(format);

            this.columns.getKrgRspTxt(format);
            this.columns.getZmenuProv(format);
            this.columns.getSerCisloElObraz(format);
            this.columns.getIxbElp(format);
            this.columns.getSerCisloElp(format);
            this.columns.getCisloMaterialu(format); // thazmuka (27.10.2021)

            this.columns.getUzivSloupec(format, this.epk_uziv_sl_fn);

            return this.getStringNamesOfColumns(format.columns);
        }

        public gridFormatBasic(format: Gordic.Data.GridFormat) {


            this.columns.getTerminVyrizeni(format, this.gin_epk_updoter);
            this.columns.getPriorita(format);

            this.columns.getUzo(format, this.readonly);

            if (this.povoleniFikceVyrizeni === true)
                this.columns.getPrizFikceVyrizen(format);           // thazmuka 13.10.2021 - příznak fikce vyřízení

            this.columns.getRequestAttachment(format);
            this.columns.getTechnickeVlastnosti(format);
        
            this.columns.getTypPoz(format);

            this.columns.getSettlementReason(format);


            this.columns.getTermin(format);
            this.columns.getFunKomu(format);
            this.columns.getTypPozadPodTxt(format);

            this.columns.getNavaznost(format);

            this.columns.getTypEntity(format);
            this.columns.getStavPisemnost(format);
            this.columns.getSouvisDok(format);
            this.columns.getCj(format, this.znackaShortText);
            this.columns.getCjSpis(format, this.textCJShortDBParam, this.isFazeUsu);
            this.columns.getVec(format);
            this.columns.getVecSpis(format);

            this.columns.getFunOdNazev(format);
            this.columns.getDatPozad(format);
            this.columns.getNazevFunAkt(format);
            this.columns.getNazevSuAkt(format);
            this.columns.getSouborPri(format);
            this.columns.getPocPriloh(format);
            this.columns.getNazevTyp(format);

            this.columns.getNazevSablony(format);

            if (this.ssl_epk_plus2 === true) {
                this.columns.getIxsSuDoNazev(format);
                this.columns.getIxsFunDoNazev(format);
            }

            this.columns.getKrgRspTxt(format);
            this.columns.getZmenuProv(format);
            this.columns.getNazevPrimAgendy(format);
            this.columns.getIxp(format);
            this.columns.getSerCisloElObraz(format);
            this.columns.getIxbElp(format);
            this.columns.getSerCisloElp(format);
            this.columns.getCisloMaterialu(format); // thazmuka (27.10.2021)

            this.columns.getUzivSloupec(format, this.epk_uziv_sl_fn);

            return this.getStringNamesOfColumns(format.columns);
        }

        public gridFormatEko(format: Gordic.Data.GridFormat) {
            this.columns.getEkoColumns(format);
            return this.getStringNamesOfColumns(format.columns);
        }

        /**
         * přidat názvy sloupců do řetězce
         */
        private getStringNamesOfColumns(columns: GGridColumn<any>[]) {
            var columnList = "";
            for (var index = 0; index < columns.length; index++) {
                // přidání čárky před přidaný název, z výjimkou prvního názvu
                columnList = index === 0 ? columnList : columnList + ",";
                columnList += columns[index].name;
            }
            return columnList;
        }

    }

    export class GEpkGridFormatColumnsInternal {

        private globalSettings?: Gordic.Data.IGStorage | null;

        constructor(globalSettings?: Gordic.Data.IGStorage | null) {
            this.globalSettings = globalSettings;   
        }

        public getEkoColumns(format: Gordic.Data.GridFormat<Gordic.Wfl.Interface.GPodpisovaKnihaDto>, fragment?: string) {

            this.getPIDPrimDokladu(format);

            var ekoformat = new Gordic.Data.GridFormat<Gordic.Wfl.Interface.GPodpisovaKnihaDto>();

            ekoformat
                .addTextColumn({ name: "ac_ag_eko", caption: "jres:32000276", width: 200 }) //RC 32000276 : Ag. číslo prim. dokladu
                .addTextColumn({ name: "nazev_typ_eko", caption: "jres:32000277", width: 200 }) //RC 32000277 : Typ prim. dokladu
                .addTextColumn({ name: "ixs_esu_eko_ico", caption: "jres:32000279", width: 200 }) //RC 32000279 : IČO
                .addTextColumn({ name: "ixs_esu_eko_nazev", caption: "jres:32000280", width: 200 }) //RC 32000280 : Název subjektu
                .addTextColumn({ name: "ixs_esu_eko_adresa", caption: "jres:32000281", width: 200 }) //RC 32000281 : Adresa subjektu
                .addTextColumn({ name: "popis_eko", caption: "jres:32000282", width: 200 }) //RC 32000282 : Popis dokladu
                .addCurrencyColumn({ name: "c_mena_eko", caption: "jres:32000283", width: 200, align: "right" }) //RC 32000283 : Celková částka
                .addTextColumn({ name: "mena_eko_zkr", caption: "jres:32000284", width: 200 }) //RC 32000284 : Měna
                .addCurrencyColumn({ name: "c_celk_eko", caption: "jres:32000285", width: 200, align: "right" }) //RC 32000285 : Celková částka v CZK
                .addCurrencyColumn({ name: "c_sch_eko", caption: "jres:32000286", width: 200, align: "right" }) //RC 32000286 : Schv. částka v akt. roce
                .addDateColumn({ name: "dat_spl_eko", caption: "jres:32000287", width: 200 }) //RC 32000287 : Datum splatnosti
                .addTextColumn({ name: "ixp_pfk_eko", caption: "jres:32000288", width: 200 }) //RC 32000288 : PID předchozí kontroly
                .addTextColumn({ name: "popis_dfk_po", caption: "jres:32000289", width: 200 }) //RC 32000289 : Popis operace
                .addTextColumn({ name: "popis_dfk_sr", caption: "jres:32000290", width: 200 }) //RC 32000290 : Popis financování
                .addTextColumn({ name: "popis_dfk_hu", caption: "jres:32000291", width: 200 }) //RC 32000291 : Popis zaúčtování

            if (fragment != null) { // přidání fragmentu k EKO sloupcům
                for (var index = 0; index < ekoformat.columns.length; index++)
                    ekoformat.columns[index].fragment = fragment;
            }

            format.add(ekoformat);

        }

        // ----

        public getSettlementReason(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "settlement_reason", caption: "jres:32000880", width: 150 }) //RC 32000880 : Plánovaný důvod vyřízení
        }

        public getStavSchvalPredpis(format: Data.GridFormat<any>) {
            format
                .addTextColumn({
                    name: "stav_vyriz_txt",
                    caption: "jres:32000805", //RC 32000805 : Stav schval. předpisu
                    description: "jres:32000806", //RC 32000806 : Stav schvalovacího předpisu
                    width: 150,
                }) 
        }

        public getCisloMaterialu(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "cislo_bod_cele_uko", caption: "jres:32000802", width: 200 }) //RC 32000802 : Číslo materiálu
        }

        public getPIDPrimDokladu(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "ixp_prim", caption: "jres:32000302", width: 200/*, fragment: "DONE"*/ }) //RC 32000302 : PID prim. dokladu

        }

        public getSerCisloElp(format: Data.GridFormat<any>) {
            format
                .addNumberColumn({ name: "ser_cislo_elp", caption: "jres:32000300", width: 150 }) //RC 32000300 : Verze el. souboru

        }

        public getIxbElp(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "ixb_elp", caption: "jres:32000299", width: 150 }) //RC 32000299 : ID el. souboru

        }

        public getSerCisloElObraz(format: Data.GridFormat<any>) {
            format
                .addNumberColumn({ name: "ser_cislo_el_obraz", caption: "jres:26265016", width: 160 }) //RC 26265016 : Verze el. obrazu
        }

        public getKrgRspTxt(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "krg_rsp_txt", caption: "jres:32000293", width: 150 }) //RC 32000293 : Kat. schv. procesu
        }

        public getIxsFunDoNazev(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "ixs_fun_do_nazev", caption: "jres:32000620 (jres:32000705)", width: 150/*, fragment: "EKO"*/ });  //RC 32000705 : Funkce
        }

        public getIxsSuDoNazev(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "ixs_su_do_nazev", caption: "jres:32000620 (jres:32000704)", width: 150 });  //RC 32000704 : Spisový uzel
        }

        public getNazevTyp(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "nazev_typ", caption: "jres:26265029", width: 140 }) //RC 26265029 : Typ dokumentu
        }

        public getPocPriloh(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "poc_priloh", caption: "jres:26265007", width: 100 }) //RC 26265007 : El. příloh
        }

        public getSouborPri(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "soubor_pri", caption: "jres:32000304", width: 50 }) //RC 32000304 : Přípona el. obrazu
        }

        public getNazevSuAkt(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "nazev_su_akt", caption: "jres:26265027", width: 150 }) //RC 26265027 : Na spisovém uzlu
        }

        public getNazevFunAkt(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "nazev_fun_akt", caption: "jres:32000594", width: 150 }) //RC 32000594 : Vlastník
        }

        public getDatPozad(format: Data.GridFormat<any>) {
            format
                .addDateTimeColumn({ name: "dat_pozad", caption: "jres:26265015", width: 150 }) //RC 26265015 : Datum požadavku

        }

        public getSouvisDok(format: Data.GridFormat<any>) {
            format
                .addIconColumn({
                    name: "exist_souv_dok",
                    description: "jres:32000034", //RC 32000034 : Související / vazby
                    caption: "jres:32000034", //RC 32000034 : Související / vazby
                    width: 30,
                    customClass: "center",
                    formatPreset: "icon",
                    iconTemplate: (data) => {
                        if (data.exist_souv_dok === 1) {
                            return {
                                text: "jres:32000009", //RC 32000009 : Související
                                icon: "gi-redistribuce",
                                tooltip: "jres:32000316: " + data.poc_souv_dok
                            }; //RC 32000316 : Souvisejících dokumentů
                        }
                        else {
                            return { icon: "", tooltip: "" };
                        }
                    }
                })
        }

        public getStavPisemnost(format: Data.GridFormat<any>) {
            format
                .addIconColumn({
                    name: "stav_pis",
                    description: "jres:32000480", //RC 32000480 : Stav dokumentu
                    caption: "jres:32000480", //RC 32000480 : Stav dokumentu
                    width: 30,
                    customClass: "center",
                    formatPreset: "icon",
                    iconTemplate: (data) => {
                        return Gordic.Wfl.Globals.ListSupport.GetIconStavDok(data);
                    }
                })
        }

        public getNavaznost(format: Data.GridFormat<any>) {
            format
                .addIconColumn({
                    name: "navaznost",
                    description: "jres:32000307", //RC 32000307 : Návaznost žádosti
                    caption: "jres:32000307", //RC 32000307 : Návaznost žádosti
                    width: 30,
                    customClass: "center",
                    formatPreset: "icon",
                    iconTemplate: (data) => {

                        var navaznost = data.navaznost;
                        if(navaznost == null)
                            navaznost = data.aktivita !== 100 ? 1 : data.sch_pov === 10 ? 2 : 0; 

                        if (navaznost === 1) {
                            // navázáno
                            return { icon: ["gi-paper g-state-background", "fa-link gi-stack-pos--rb"], tooltip: "jres:32000308" };	            //RC 32000308 : Požadavek/úkon je závislý na vyřízení jiných s nižší schvalovací úrovní.
                        }
                        else if (navaznost === 2) {
                            // nevyřízeno
                            return { icon: ["gi-paper g-state-background", "fa-exclamation gi-stack-pos--rb"], tooltip: "jres:32000309" };		//RC 32000309 : Povinný úkon
                        }
                        else {
                            return { icon: "", tooltip: "" };
                        }
                    }
                })
        }

        /**
         * vyřizuje
         */
        public getFunKomu(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "fun_komu_rf", caption: "jres:26265023", width: 150 }); //RC 26265023 : Vyřizuje
        }

        public getVyrizDokument(format: Data.GridFormat<any>) {
            format
                .addIconColumn({
                    name: "vyriz_dokument",
                    caption: "jres:32000319", //RC 32000319 : Vyřizující dokument
                    width: 40,
                    customClass: "center",
                    iconTemplate: (data) => {
                        if (data.ixb_vyriz_epk != null)
                            return { icon: "gi-paperel", tooltip: "jres:32000320" }; //RC 32000320 : Žádost obsahuje vyřizující dokument.
                        else
                            return null;
                    }
                })
        }

        public getRequestAttachment(format: Data.GridFormat<any>) {
            format
                .addIconColumn({
                    name: "request_attachment",
                    description: "jres:32000318", //RC 32000318 : Žádost na el. přílohu
                    caption: "jres:32000318", //RC 32000318 : Žádost na el. přílohu
                    width: 30,
                    customClass: "center",
                    formatPreset: "icon",
                    iconTemplate: (data) => {
                        if (data.request_attachment === 1)
                            return { icon: "gi-eattachment", text: "jres:32000317" }; //RC 32000317 : Vyřizuje se konkrétní el. příloha
                        else 
                            return { icon: "", tooltip: "" };
                    }
                })
        }

        public getUzo(format: Gordic.Data.GridFormat<any>, readonlyFunc: () => boolean) {
            format
                .addIconColumn(Gordic.Wfl.Globals.ListSupport.UzoColumn(Wfl.Interface.GColorpickerTypeEnum.Request, readonlyFunc, this.globalSettings));
        }

        public getUzivSloupec(format: Data.GridFormat<any>, epk_uziv_sl_fn: string) {
            var caption = epk_uziv_sl_fn == null ? "jres:32000421" : epk_uziv_sl_fn; //RC 32000421 : Uživatelský sloupec
            format
                .addTextColumn({ name: "epk_uziv_sl_f", caption: caption, width: 250 })
        }

        public getNazevPrimAgendy(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "typ_ag_prim_txt", caption: "jres:32000298", width: 150 }) //RC 32000298 : Název prim. agendy
        }

        public getZmenuProv(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "zmenu_prov_rf", caption: "jres:32000017", width: 150 }) //RC 32000017 : Změnu provedl
        }

        public getTypPozadPodTxt(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "typ_pozad_pod_txt", caption: "jres:32000042", width: 90 }) //RC 32000042 : Upřesnění
        }

        public getCjSpis(format: Gordic.Data.GridFormat, textCJShortDBParam: string, isFazeUsu: boolean) {
            format
                .addTextColumn({ name: "cj_spis", caption: textCJShortDBParam, visible: isFazeUsu, width: 100 })				// Sp.Zn.
        }

        public getCj(format: Gordic.Data.GridFormat, znackaShortText: string) {
            format
                .addTextColumn({ name: "cj", caption: znackaShortText, width: 100 })												// Zn.
        }

        public getVecSpis(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({
                    name: "vec_spis",
                    caption: "jres:32000735", //RC 32000735 : Věc spis
                    width: 250,
                    description: "jres:32000736" //RC 32000736 : pro dokumenty ve spisu
                }) 
        }

        public getVec(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "vec", caption: "jres:26265010", width: 250 }) //RC 26265010 : Věc
        }

        public getDatVyrizeni(format: Gordic.Data.GridFormat) {
            format
                .addDateTimeColumn({ name: "dat_vyrizeni", caption: "jres:32000294", width: 200 }) //RC 32000294 : Datum vyřízení
        }

        public getVyrizeniTxt(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "vyrizeni_txt", caption: "jres:32000295", width: 140 }) //RC 32000295 : Popis vyřízení
        }

        public getTypPoz(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "typ_poz_v_txt", caption: "jres:32000228", width: 140 }) //RC 32000228 : Provedený požadavek
        }

        public getZpusobVyriz(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "zpus_vyriz_txt", caption: "jres:26265025", width: 120 }) //RC 26265025 : Způsob vyřízení
        }

        public getNazevSablony(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "nazev_sablony", caption: "jres:32001076", width: 250 }) //RC 32001076 : Předpis
        }

        public getTechnickeVlastnosti(format: Gordic.Data.GridFormat) {
            format
                .addIconColumn(Gordic.Wfl.Globals.ListSupport.TechnickeVlastnostiColumnDlg())
        }

        public getPriorita(format: Gordic.Data.GridFormat) {

            format
                .addIconColumn({
                    name: "priorita",
                    caption: "jres:32000310", //RC 32000310 : Priorita
                    width: 30,
                    customClass: "center",
                    iconTemplate: (row) => {
                        var priority: Wfl.Interface.GEpkPriorityEnum = row.priorita;
                        var icon: IconTemplate = {};
                        if (priority === Wfl.Interface.GEpkPriorityEnum.Low) {
                            var text = "jres:32000311"; //RC 32000311 : Nízká priorita
                            icon = { icon: "fa-fw", text: text, tooltip: text };
                        }
                        else if (priority === Wfl.Interface.GEpkPriorityEnum.High) {
                            var text = "jres:32000313"; //RC 32000313 : Vysoká priorita
                            icon = { icon: "fa-exclamation-triangle g-state-text g-state-important", text: text, tooltip: text };
                        }
                        else if (priority === Wfl.Interface.GEpkPriorityEnum.Critical) {
                            var text = "jres:32000586"; //RC 32000586 : Kritická priorita
                            icon = { icon: "fa-exclamation-triangle g-state-text g-state-error", text: text, tooltip: text };
                        }
                        else {
                            var text = "jres:32000312"; //RC 32000312 : Střední priorita
                            icon = { icon: "fa-exclamation-triangle g-state-text g-state-warning", text: text, tooltip: text };
                        }
                        return icon;
                    }
                })

        }

        public getTypEntity(format: Gordic.Data.GridFormat) {
            format
                .addIconColumn(Gordic.Wfl.Globals.ListSupport.TypEntityColumnDlg())
        }

        public getTermin(format: Gordic.Data.GridFormat) {
            format
                .addDateTimeColumn({ name: "dat_vyriz_plan", caption: "jres:32000090", width: 140/*, fragment: "BASE"*/ }) //RC 32000090 : Termín
        }

        /**
         * vyřizoval
         * @param format
         */
        public getFunVyriz(format: Data.GridFormat<any>) {
            format
                .addTextColumn({ name: "ixs_zmp_vyriz_nazevrf", caption: "jres:32000771", width: 150 }); //RC 32000771 : Vyřizoval
        }

        public getFunOdNazev(format: Gordic.Data.GridFormat) {
            // thazmuka (26.8.2021) - upraveno
            format
                .addTextColumn({ name: "ixs_zmp_od_nazevrf", caption: "jres:26265011", width: 150 }) //RC 26265011 : Žadatel
        }

        public getIxp(format: Gordic.Data.GridFormat) {
            format
                .addTextColumn({ name: "ixp", caption: "jres:32000048", width: 120 }) //RC 32000048 : PID
        }

        public getPrizFikceVyrizen(format: Gordic.Data.GridFormat) {
            format
            .addIconColumn({
                groupings: {
                    "default": {
                        _presetCaption: "jres:32000743", //RC 32000743 : Dle hodnoty
                        grouping: {
                            hideColumn: false,
                            hash: function (meta) {
                                return meta.data.priz_fikce_vyrizen;
                            },
                            captionText: (row) => {
                                if (row.data.priz_fikce_vyrizen === 1) {
                                    var text = "jres:32000790"; //RC 32000790 : Příznak fikce vyřízení je nastaven.
                                    return text;
                                }
                                return "jres:32000744"; //RC 32000744 : Neurčeno
                            }
                        }
                    }
                },
                name: "priz_fikce_vyrizen",
                caption: "jres:32000791", //RC 32000791 : Fikce vyřízení
                width: 30,
                customClass: (meta, info: any) => {
                    var customClass = info.formatPreset === Gordic.Global.Enums.GridColumnFormatIcon.icon ? "center" : "left";
                    return customClass;
                },
                iconTemplate: (data: Gordic.Wfl.Interface.GPodpisovaKnihaDto) => {
                    var iconTemplate: IconTemplate = {
                        icon: "fa-fw",
                        text: "",
                        tooltip: ""
                    };
                    if (data.priz_fikce_vyrizen === 1) {
                        var text = "jres:32000790"; //RC 32000790 : Příznak fikce vyřízení je nastaven.
                        iconTemplate = { icon: "gi-vyrizenopred_bold g-state-text g-state-info|gi-settings g-state-info gi-stack-pos--rb ", text: text, tooltip: text };
                    }
                    return iconTemplate;
                }
            })
        }

        public getTerminVyrizeni(format: Gordic.Data.GridFormat, gin_epk_updoter: number) {
            format
                .addIconColumn({
                    name: "termin_vyrizeni",
                    caption: "jres:32000306", //RC 32000306 : Termín vyřízení
                    width: 30,
                    groupings: {
                        "default": {
                            _presetCaption: "jres:32000743", //RC 32000743 : Dle hodnoty
                            grouping: {
                                hideColumn: false,
                                hash: function (meta) {
                                    return meta.data.termin_vyrizeni;
                                },
                                captionText: (row) => {
                                    if (row.data.termin_vyrizeni === 1) {      
                                        var text = "jres:26265030"; //RC 26265030 : Nevyřízeno po
                                        return text;
                                    }
                                    else if (row.data.termin_vyrizeni === 2) {  
                                        var text = "jres:26265031"; //RC 26265031 : Nevyřízeno těsně před
                                        return text;
                                    }
                                    else if (row.data.termin_vyrizeni === 3) {  
                                        var text = "jres:26265032"; //RC 26265032 : Nevyřízeno před
                                        return text;
                                    }
                                    return "jres:32000744"; //RC 32000744 : Neurčeno
                                }
                            }
                        }
                    },
                    customClass: (meta, info: any) => {
                        var customClass = info.formatPreset === Gordic.Global.Enums.GridColumnFormatIcon.icon ? "center" : "left";
                        return customClass;
                    },
                    iconTemplate: (data) => { 

                        var iconTemplate: IconTemplate = {
                            icon: "fa-fw",
                            text: "",
                            tooltip: ""
                        };

                        if (data.dat_vyriz_plan == null)
                            return iconTemplate;

                        // datum plánovaného vyřízení (string to date)
                        // odečíst toto datum od dneška (new Date())
                        // a rozdíl zobrazit jako jednotlivé dny
                        var dat_vyriz_plan = data.dat_vyriz_plan;
                        if (typeof data.dat_vyriz_plan === "string") 
                            dat_vyriz_plan = Gordic.Utils.DateTime.parse(data.dat_vyriz_plan);
                        
                        var today = new Date() as any;

                        // rozdíl jako dny
                        let diff_days = Gordic.Utils.DateTime.diff(today, dat_vyriz_plan, "days");


                        if (diff_days < 0) {
                            var text = "jres:26265030"; //RC 26265030 : Nevyřízeno po
                            iconTemplate = { icon: "gi-vyrizenopo_bold g-state-text g-state-error", text: text, tooltip: text };
                        }
                        else if (diff_days < gin_epk_updoter) {
                            var text = "jres:26265031"; //RC 26265031 : Nevyřízeno těsně před
                            iconTemplate = { icon: "gi-vyrizenopred_bold g-state-text g-state-warning", text: text, tooltip: text };
                        }
                        else {
                            var text = "jres:26265032"; //RC 26265032 : Nevyřízeno před
                            iconTemplate = { icon: "gi-vyrizenopred_bold g-state-text g-state-info", text: text, tooltip: text };
                        }
                        return iconTemplate;
                    }
                })
        }

    }

}